import { gql } from "@apollo/client";

export const createDownloadLog = gql`
  mutation createDownloadLog($data: DocumentsTrackingInput!) {
    createDownloadLog(data: $data) {
      email
      userName
      role
      uid
      documentName
    }
  }
`
